
import { z } from "zod";
import { ModalFrequency } from "@/types/modal";
import { ModalCampaignQuestionFormData } from "@/types/modalCampaigns";

// Create schema for campaign form
export const campaignFormSchema = z.object({
  title: z.string().min(1, "Titel is verplicht"),
  content: z.string().min(1, "Inhoud is verplicht"),
  start_date: z.date({
    required_error: "Startdatum is verplicht",
  }),
  end_date: z.date({
    required_error: "Einddatum is verplicht",
  }),
  frequency: z.enum(["once", "hourly", "daily", "weekly", "monthly", "every_minute", "every_login"]),
  users: z.array(z.string()).min(1, "Selecteer ten minste één gebruiker"),
  has_quiz: z.boolean().default(false),
  min_score: z.number().min(1).optional(),
  max_attempts: z.number().int().positive().optional(),
  repeat_on_failure: z.boolean().default(true),
  allow_dismiss: z.boolean().default(true),
});

// Create type from schema
export type CampaignFormValues = z.infer<typeof campaignFormSchema>;

export interface UseCampaignFormProps {
  currentUser: User | null;
  existingCampaign: ModalCampaign | null;
  assignedUsers: string[];
  onSuccess: () => void;
}

// Re-export User and ModalCampaign types to avoid circular dependencies
import { User } from "@/context/AuthContext";
import { ModalCampaign } from "@/types/modalCampaigns";
